module.exports = __webpack_public_path__ + "img/help_graphical.858b313c.svg";